// Generated by CoffeeScript 2.7.0
var TransformUserPopover;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export default TransformUserPopover = Vue.extend({
  mixins: [PopoverGroupOptionsMixin],
  props: {
    initialSelectedUser: {
      type: Object,
      default: null
    },
    userType: {
      type: String
    }
  },
  components: {
    'Popover': Popover
  },
  data: function() {
    return {
      selectedUser: this.initialSelectedUser
    };
  },
  template: `  <Popover position="bottom"
          :caret='false'
          :blockContent='true'
          customClass='select'
          ref='popoverVm'>
  <template slot='trigger'>
    <div class="input-control right-addon justify-box" ref='searchInput'>
      <div class="controlled-input">{{ displayValue }}</div>
      <div class="addon">
        <i class="slp-caret-down"></i>
      </div>
    </div>
  </template>
  <template slot='content'>
    <popover-group-options optionsFilterPlaceholder='搜索用户'
                           :multiple='false'
                           :formatDataFunc='formatDataFunc'
                           :needFooter='false'
                           @valueChanged='valueChangedFunc'
                           @keywordUpdated='keywordUpdatedFunc'
                           @cancelClicked='userSelectCancelFunc'
                           @submitClicked='submitFunc'
                           ref='popoverGroupOptionsRef'>
    </popover-group-options>
  </template>
</Popover>`,
  computed: {
    displayValue: function() {
      if (this.selectedUser) {
        return this.selectedUser.name;
      } else {
        return '请选择';
      }
    }
  },
  methods: {
    formatDataFunc: function() {
      return [];
    },
    submitFunc: function() {
      this.userSelectCancelFunc();
      return this.resetPopoverGroupOptionsRef();
    },
    valueChangedFunc: function(option) {
      if (this.selectedUser === option) {
        option._selected = false;
        this.selectedUser = null;
      } else {
        this.selectedUser = option;
        option._selected = true;
      }
      return this.$emit('valueChanged', this.selectedUser, this.userType);
    },
    userSelectCancelFunc: function() {
      return this.$refs.popoverVm.close();
    },
    keywordUpdatedFunc: function(keyword) {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('users/query', {
        name: keyword
      }), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data, xhr) => {
          return this.$refs.popoverGroupOptionsRef.updateGroupedOptions([
            {
              id: Skylark.Helpers.Utilities.uuid(),
              options: _.each(data,
            (item) => {
                var ref;
                return item._selected = ((ref = this.selectedUser) != null ? ref.id : void 0) === item.id;
              })
            }
          ]);
        }
      });
    }
  }
});
